import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DealTagEntityParams {
  product_id?: number | string;
  product_line_id: number | string;
  discount_string?: string;
}
export class DealTagEntity extends BaseEntityClass {
  product_id?: number | string;
  product_line_id: number | string;
  discount_string?: string;
  constructor(params: DealTagEntityParams) {
    super();
    this.type = "deal_tag";
    this.entity_version = 2;
    this.product_line_id = params.product_line_id;
    this.product_id = params.product_id;
    this.discount_string = params.discount_string;
  }
}
